module.exports = __webpack_public_path__ + "img/hourglass.b1ced30d.svg";